import {
  TRAILSINFO_FINGERPRINT_SET,
  TRAILSINFO_FINGERPRINT_REQUEST,
  TRAILSINFO_FINGERPRINT_STATUS_RESET,
  TRAILSINFO_FINGERPRINT_SUCCESS,
  TRAILSINFO_FINGERPRINT_ERROR,
  MITIGATE_FINGERPRINT_SET,
  MITIGATE_FINGERPRINT_REQUEST,
  MITIGATE_FINGERPRINT_STATUS_RESET,
  MITIGATE_FINGERPRINT_SUCCESS,
  MITIGATE_FINGERPRINT_ERROR
} from './trailsinfo.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import Trail from '@/resources/models/Trail'
import { trailsMetaInfo } from '@/column-header/trail/trails-meta'
import { OrderByEnum } from '@/constants/orderby.constants'

const state = {
  trailsinfoFingerprintReqStatus: '',
  trailsinfoFingerprintRecords: {},
  fingerprintMitigationReqStatus: ''
}

const getters = {
  trailsinfoFingerprintReqStatus: state => state.trailsinfoFingerprintReqStatus,
  trailsinfoFingerprintRecords: state => state.trailsinfoFingerprintRecords,
  fingerprintMitigationReqStatus: state => state.fingerprintMitigationReqStatus
}

// Best Practice - updates state
const mutations = {
  [TRAILSINFO_FINGERPRINT_SET]: (state, { trailState, data } = {}) => {
    state.trailsinfoFingerprintRecords = data
  },
  [TRAILSINFO_FINGERPRINT_REQUEST]: state => {
    state.trailsinfoFingerprintReqStatus = 'loading'
  },
  [TRAILSINFO_FINGERPRINT_STATUS_RESET]: state => {
    state.trailsinfoFingerprintReqStatus = ''
  },
  [TRAILSINFO_FINGERPRINT_SUCCESS]: (state, data) => {
    state.trailsinfoFingerprintReqStatus = 'saved'
  },
  [MITIGATE_FINGERPRINT_ERROR]: (state, errMsg) => {
    state.fingerprintMitigationReqStatus = 'error'
  },
  [MITIGATE_FINGERPRINT_SET]: (state, { trailState, data } = {}) => {
    state.fingerprintMitigationReqStatus = 'saved'
  },
  [MITIGATE_FINGERPRINT_REQUEST]: state => {
    state.fingerprintMitigationReqStatus = 'loading'
  },
  [MITIGATE_FINGERPRINT_STATUS_RESET]: state => {
    state.fingerprintMitigationReqStatus = ''
  },
  [MITIGATE_FINGERPRINT_SUCCESS]: (state, data) => {
    state.fingerprintMitigationReqStatus = 'saved'
  },
  [MITIGATE_FINGERPRINT_ERROR]: (state, errMsg) => {
    state.fingerprintMitigationReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [TRAILSINFO_FINGERPRINT_REQUEST] (context, fingerprintId) {
    let fingerprintIdEncoded = encodeURIComponent(fingerprintId)
    return new Promise((resolve, reject) => {
      context.commit(TRAILSINFO_FINGERPRINT_REQUEST)
      ApiRest()
        .get(`trails/fingerprint/${fingerprintIdEncoded}`)
        .then(({ data }) => {
          data = _.chain(data)
            .sort((a, b) => {
              return b.riskScore - a.riskScore
            })
            .map(trail => {
              let attackTrail = new Trail('trailIdHash', trail)
              attackTrail.configureKillChainFormat()
              return attackTrail
            })
            .value()

          data = new IQCollection(
            data,
            { attributes: trailsMetaInfo.meta.columns },
            { defaultSort: 'progressionSeverity', sortOrder: OrderByEnum.DESC }
          )

          context.commit(TRAILSINFO_FINGERPRINT_SET, { data: data })
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(TRAILSINFO_FINGERPRINT_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TRAILSINFO_FINGERPRINT_SUCCESS] (context) {
    context.commit(TRAILSINFO_FINGERPRINT_SUCCESS)
  },
  [TRAILSINFO_FINGERPRINT_STATUS_RESET] (context) {
    context.commit(TRAILSINFO_FINGERPRINT_STATUS_RESET)
  },
  [MITIGATE_FINGERPRINT_REQUEST] (context, payload) {
    let fingerprintIdEncoded = encodeURIComponent(payload.fingerprintId)
    return new Promise((resolve, reject) => {
      context.commit(MITIGATE_FINGERPRINT_REQUEST)
      ApiRest()
        .post(`/trails/fingerprint/mitigate/${fingerprintIdEncoded}`, {
          trails: payload.trails,
          assigned_from: payload.assignFrom,
          owner_id: payload.assignTo
        })
        .then(({ data }) => {
          context.commit(MITIGATE_FINGERPRINT_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(MITIGATE_FINGERPRINT_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/trails/trailsinfo-fingerprint.module.js